import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthShell from '../comps/authShell'
import { Input, InputErrorMassage } from '../comps/comps'
import { getSignupDraft, setSignupDraft } from '../utils/signupDraft'

const AuthName = () => {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [tried, setTried] = useState(false)

  useEffect(() => {
    const draft = getSignupDraft()
    if (!draft.email || !draft.password) navigate('/auth', { replace: true })
    if (draft.name) setName(draft.name)
  }, [navigate])

  const next = () => {
    setTried(true)
    if (name.length < 3 || name.length > 15) return
    setSignupDraft({ name })
    navigate('/auth/setup/bio')
  }

  return (
    <AuthShell title="Your name">
      <p className="authStepLabel">What should we call you?</p>
      <Input placeholder="Enter your name" value={name} onChange={e => setName(e.target.value)} />
      {tried && <InputErrorMassage val={name} num={[3, 15]} text="name should be 3 to 15 letters" />}
      <button type="button" className="googlebuttons" onClick={next}>Next</button>
      <p className="googlebuttonss" onClick={() => navigate('/auth/setup/password')}>Back</p>
    </AuthShell>
  )
}

export default AuthName
